import { ModuleWithProviders, NgModule } from '@angular/core';
import { ExtensionAppIntegrationComponent } from './extension-app-integration.component';
import { TeacherWrapperModule } from './push-the-button-integration/teacher-wrapper/teacher-wrapper.module';
import { BeamerWrapperModule } from './push-the-button-integration/beamer-wrapper/beamer-wrapper.module';
import { EffectsModule } from '@ngrx/effects';
import { ExtensionAppEmitterEffects } from './state/extension-app-emitter-effects.service';
import { StoreModule } from '@ngrx/store';
import * as fromExtensionApp from './state/extension-app.reducer';
import { StudentWrapperModule } from './push-the-button-integration/student-wrapper/student-wrapper.module';

/**
 * Base module for extension app integration.
 *
 * Note: Service injection is now handled directly by extension apps using
 * @pcp/auth, @pcp/streaming, and @pcp/http. No forRoot() configuration needed.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(fromExtensionApp.extensionAppFeatureKey, fromExtensionApp.reducer),
        ExtensionAppIntegrationComponent,
    ],
    exports: [ExtensionAppIntegrationComponent],
})
export class BaseExtensionAppIntegrationModule {}

@NgModule({
    declarations: [],
    imports: [
        BaseExtensionAppIntegrationModule,
        TeacherWrapperModule,
        EffectsModule.forFeature([ExtensionAppEmitterEffects]),
    ],
    exports: [BaseExtensionAppIntegrationModule, TeacherWrapperModule],
})
export class ExtensionAppIntegrationModuleForTeacher {}

@NgModule({
    declarations: [],
    imports: [
        BaseExtensionAppIntegrationModule,
        BeamerWrapperModule,
    ],
    exports: [BaseExtensionAppIntegrationModule, BeamerWrapperModule],
})
export class ExtensionAppIntegrationModuleForBeamer {}

@NgModule({
    declarations: [],
    imports: [
        BaseExtensionAppIntegrationModule,
        StudentWrapperModule,
    ],
    exports: [BaseExtensionAppIntegrationModule, StudentWrapperModule],
})
export class ExtensionAppIntegrationModuleForStudent {}

@NgModule({})
export class ExtensionAppIntegrationModule {
    static forTeacher(): ModuleWithProviders<ExtensionAppIntegrationModuleForTeacher> {
        return {
            ngModule: ExtensionAppIntegrationModuleForTeacher,
            providers: [],
        };
    }

    static forBeamer(): ModuleWithProviders<ExtensionAppIntegrationModuleForBeamer> {
        return {
            ngModule: ExtensionAppIntegrationModuleForBeamer,
            providers: [],
        };
    }

    static forStudent(): ModuleWithProviders<ExtensionAppIntegrationModuleForStudent> {
        return {
            ngModule: ExtensionAppIntegrationModuleForStudent,
            providers: [],
        };
    }
}
